import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminAuditTrail = lazy(() => import("@/pages/admin/AdminAuditTrail"));

export const Route = createFileRoute("/admin/arenden/granskningslogg")({
  head: () => ({ meta: [{ title: "Granskningslogg – Adminpanel" }] }),
  component: AdminAuditTrail,
});
